<template>
    <section class="filter-results">
        <filter-results-display class="filter-results__display"
                                :shown="shown"
                                :total="total"
                                @clear="clearFilters" />
    </section>
</template>

<script>

import PlanBuilderManager from '@/plan-builder-manager'

import FilteredDataHandler from './filtered-data-handler'
import FilterResultsDisplay from './filter-results-display'

export default {

    mixins: [
        FilteredDataHandler,
    ],

    computed: {

        shown() {
            return this.filteredImprovements.length
        },

        total() {
            return this.currentProject.availableImprovements.length
        },
    },

    methods: {

        clearFilters() {
            PlanBuilderManager.filterDisplayedImprovements('recommended', false)
            PlanBuilderManager.filterDisplayedImprovements('selected', false)
            PlanBuilderManager.filterDisplayedImprovementsBySegment(this.$scheme.segmentKeymap, this.visibleSegments.map(seg => seg.key))
        },
    },

    components: {
        FilterResultsDisplay,
    },
}

</script>
